var PanelCard={Header:{CloseAction:{accessibilityLabel:"Close {title} Panel."},RollupMenu:{accessibilityLabel:"View actions for {title}"}}};var _en = {PanelCard:PanelCard};

export { PanelCard, _en as default };
